import { render, staticRenderFns } from "./ResiliationForm.vue?vue&type=template&id=52f13cc8&"
import script from "./ResiliationForm.vue?vue&type=script&lang=js&"
export * from "./ResiliationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports